import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ThemeMode = "light" | "dark";

interface ThemeState {
    currentTheme: ThemeMode;
}

const initialState: ThemeState = {
    currentTheme: "light", // Default to light mode
};

const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        setTheme: (state, action: PayloadAction<ThemeMode>) => {
            state.currentTheme = action.payload;
        },
        toggleTheme: state => {
            state.currentTheme = state.currentTheme === "light" ? "dark" : "light";
        },
    },
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export default themeSlice;
